import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { superbillAnalysesActions } from 'features/superbillAnalyses';

const useSuperbillAnalyses = () => {
  const dispatch = useDispatch();
  const getSuperbillAnalyses = useCallback(({ offset }) => dispatch(superbillAnalysesActions.getSuperbillAnalyses({ offset })), [dispatch]);
  const getSuperbillAnalysis = useCallback(({ id, cable }) => dispatch(superbillAnalysesActions.getSuperbillAnalysis({ id, cable })), [dispatch]);
  const clearLocalSuperbillAnalyses = useCallback(() => dispatch(superbillAnalysesActions.clearLocalSuperbillAnalyses()), [dispatch]);
  const clearLocalActiveSuperbillAnalysis = useCallback(() => dispatch(superbillAnalysesActions.clearLocalActiveSuperbillAnalysis()), [dispatch]);

  return {
    getSuperbillAnalyses,
    getSuperbillAnalysis,
    clearLocalSuperbillAnalyses,
    clearLocalActiveSuperbillAnalysis
  };
};

export default useSuperbillAnalyses;